import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/lib/api/client';

/**
 * Retry policy is deliberate rather than default.
 *
 * Retrying a 401/403/404/422 is pointless — the answer will not change — and
 * retrying a 401 in particular races the single-flight token refresh. Only
 * genuine transport and server failures are worth a second attempt.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          if (error.status >= 400 && error.status < 500) return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      // Never retry a mutation automatically: without an idempotency key the
      // server could apply it twice.
      retry: false,
    },
  },
});
